import _ from "lodash";

import client from "lib/apolloClient/client";

import {
  configurationItemFragment,
  configurationUpdateFragment,
} from "./Fragments";

import { parseConfigurationValue } from "Utils/Common.js";

import { getConfigurationQuery } from "./Queries";

const generateConfigurationUid = ({ context, configurationName }) => {
  const entityGroupsParsed = _.map(
    context,
    ({ entityType, entityId }) => `${entityType}::${entityId}`
  );
  return _.concat(entityGroupsParsed, [configurationName]).join("::");
};

export const getConfigurationValueFromCache = ({
  context,
  configurationName,
}) => {
  const id = generateConfigurationUid({ context, configurationName });

  const result = client.readFragment({
    id,
    fragment: configurationItemFragment,
    fragmentName: "configurationV2Item",
  });

  return result ? parseConfigurationValue(result) : false;
};

export const getConfigurationFromCache = ({ context, configurationName }) => {
  const id = generateConfigurationUid({ context, configurationName });

  const result = client.readFragment({
    id,
    fragment: configurationItemFragment,
    fragmentName: "configurationV2Item",
  });

  return result ? result : {};
};

export const writeConfigurationInCache = ({
  cache,
  context,
  configurationName,
  value,
}) => {
  const id = generateConfigurationUid({ context, configurationName });

  const existing = cache.readFragment({
    id,
    fragment: configurationItemFragment,
    fragmentName: "configurationV2Item",
  });

  if (existing) {
    cache.writeFragment({
      id,
      fragment: configurationItemFragment,
      fragmentName: "configurationV2Item",
      data: {
        ...existing,
        value,
      },
    });
  }
};

export const readConfigurationForUpdate = ({
  context,
  configurationName,
  fragmentVariables,
}) => {
  const id = generateConfigurationUid({ context, configurationName });

  const result = client.readFragment({
    id,
    fragment: configurationUpdateFragment,
    fragmentName: "configurationV2UpdateItem",
    variables: fragmentVariables,
  });

  return result ? result : {};
};

export const writeConfigurationForUpdate = ({
  cache,
  context,
  configurationName,
  data,
  fragmentVariables,
}) => {
  const id = generateConfigurationUid({ context, configurationName });
  cache.writeFragment({
    id,
    fragment: configurationUpdateFragment,
    fragmentName: "configurationV2UpdateItem",
    variables: fragmentVariables,
    data,
  });
};

export const getConfigurationsFromCache = variables => {
  const result = client.readQuery({
    query: getConfigurationQuery,
    variables,
  });

  return _.get(result, "platform.configuration", []);
};
